module.exports = __webpack_public_path__ + "img/weddings_02_H.abe6d111.webp";